export default function (Vue){
  const filterObj  = {
    // 时间转换
    formatterTime: (value, str) => {
      if(value == null) return '--';
      let date = new Date(value);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let min = date.getMinutes();
      let sen = date.getSeconds();
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      hour = hour < 10 ? '0' + hour : hour;
      min = min < 10 ? '0' + min : min;
      sen = sen < 10 ? '0' + sen : sen;
      if(typeof str === 'string') { return str.replace(/yyyy/i, year).replace(/mm/i, month).replace(/dd/i, day).replace(/min/i, min).replace(/hh/i, hour).replace(/ss/i, sen); }
      return  year + '-' + month + '-' + day + '   ' + hour + ':' + min + ":" + sen;
    },
    // 时间转换
    formatTime: (value, str) => {
      if(value == null) return '--';
      let date = new Date(value);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      if(typeof str === 'string') { return str.replace(/yyyy/i, year).replace(/mm/i, month).replace(/dd/i, day); }
      return  year + '-' + month + '-' + day;
    },
    // 过滤掉 html 标签
    filterHtmlTab: (msg) => {
      if(typeof msg === "string") {
        msg = msg.replace(/<\/?br\/?>/g, ',');
        msg = msg.replace(/<\/?[^>]+>/g, ''); //去除HTML Tag
        msg = msg.replace(/[|]*\n/, ',') //去除行尾空格
        msg = msg.replace(/&npsp;/ig, ''); //去掉npsp
        return msg;
      }
      if(msg == null) {
        return '--'
      }
      return msg
    },
    money:(val) => {
      if(typeof val === 'string'&&val.match(','))return val;
      if(val === null||val === undefined)return '0.00'
      val = val.toString().replace(/\$|\\,/g,'');
      if(isNaN(val)) {
        val = "0";
      }
      let sign = (val == (val = Math.abs(val)));
      val = Math.floor(val*100+0.50000000001);
      let cents = val%100;
      val = Math.floor(val/100).toString();
      if(cents<10) {
        cents = "0" + cents
      }
      for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
        val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
      }
      return (((sign)?'':'-') + val + '.' + cents);
    },
    // .换成-
    filterPoint: (msg) => {
      if(typeof msg === "string") {
        msg = msg.replace(/\./ig, '-');
        return msg;
      }
      if(msg == null) {
        return '--'
      }
      return msg
    },

    // br 换成 空格
    brToSpace(msg){
      if(typeof msg === "string") {
        msg = msg.replace(/<br(\s)?\/?>/ig, ' ');
        return msg;
      }
      return msg
    }
  }
  for ( let key in filterObj){
    Vue.filter(key, filterObj[key]);
  }
}